import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Route } from 'react-router'
import { BrowserRouter as Router, Switch, Redirect, useHistory, useLocation } from 'react-router-dom'
import { unwrapResult } from '@reduxjs/toolkit'
import Navbar from './components/Navbar'
import { ActiveVarsList } from './features/activeVarsList/ActiveVarsList'
import { PendingVarsList } from './features/pendingVarsList/PendingVarsList'
import { HistoryVarsList } from './features/historyVarsList/HistoryVarsList'
import { VarPage } from './features/var/VarPage'
import { Test } from './features/test'
import { VarEditForm } from './features/var/VarEditForm'
import { ProfileForm } from './features/user/Profile'
import { UserLanguageForm } from './features/user/UserLanguage'
import { HelpForm } from './features/user/Help'
import LogingLogo from './images/loging_logo.png'
import MicrosoftLogo from './images/microsoft.png'
import { login, logout, getCookie, setCookie, recoveryPassword } from './features/user/user'
import { TextField, makeStyles, Container, Box, Grid, Card, Button, Typography, withStyles } from '@material-ui/core'
import CustomizedSnackbars from './components/abstractObjects/Snackbars'
import AlertDialog from './components/abstractObjects/AlertDialog'
import { ToShortDate } from './components/abstractObjects/Date'
import AskPushSubscription from './FcmInit'
import { Translation } from './features/translations/getTranslation'
import { fetchCountries } from './features/countries/countriesSlice'
import { fetchLanguages } from './features/languages/languagesSlice'
import { fetchTranslations } from './features/translations/translationsSlice'
import { fetchDevices } from './features/devices/devicesSlice'
import { fetchSupervisors } from './features/supervisors/supervisorsSlice'
import { fetchVarFieldAttachments } from './features/varFieldAttachments/varFieldAttachmentsSlice'
import { setEditVarId } from './features/var/varSlice'
import * as Sentry from "@sentry/react";
import { createBrowserHistory } from 'history';

const urlRedirectMicrosoft = `${window.location.protocol}//${window.location.host}`;

const footerCss = makeStyles({
    root: {
        padding: "1rem"
    }
})

const textFieldCss = makeStyles({
    root: {
        '& .MuiFormLabel-root': {
            color: '#4db5ff'
        },
        '& .MuiInput-underline': {
            color: '#1861ac'
        }
    }
})

const BlueButton = withStyles({
    root: {
        color: "white",
        width: "100%",
    },
    disabled: {
        backgroundColor: '#4db5ff !important',
        color: "white !important",
    }
})((props) => <Button {...props} />)

Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_IO_DSN,
    environment: process.env.REACT_APP_SENTRY_IO_ENVIRONMENT,
    integrations: [
        new Sentry.BrowserTracing({
            routingInstrumentation: Sentry.reactRouterV5Instrumentation(
                React.useEffect,
                useLocation
            ),
        }),
        new Sentry.Replay()
    ],
    tracesSampleRate: process.env.REACT_APP_SENTRY_IO_TRACES_RATE
});

const SentryRoute = Sentry.withSentryRouting(Route);
const history = createBrowserHistory();

const Logout = (setSnackObj, setSnackActive, setRegistryLoaded) => {
    const history = useHistory()
    const dispatch = useDispatch()

    var logoutAction = async () => {
        try {
            await dispatch(logout())
            history.push("/")
            setRegistryLoaded(false)
            setSnackObj({ message: 'You are logged out', type: 'success' })
            setSnackActive(true)
            window.location.href = `https://${process.env.REACT_APP_AZUREB2C_TENANT_NAME}.b2clogin.com/${process.env.REACT_APP_AZUREB2C_TENANT_ID}/${process.env.REACT_APP_AZUREB2C_POLICY_SIGNIN_SIGNUP}/oauth2/v2.0/logout?post_logout_redirect_uri=${urlRedirectMicrosoft}`
        } catch (err) {
            console.error('Failed to logout: ', err)
        }
    }

    logoutAction()
    return <React.Fragment>Logout..</React.Fragment>
}

const isIOS = () => {
    var isSafari = !navigator.userAgent.match(/Version\/[\d.]+.*Safari/);
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    return iOS && isSafari;
}

let App = () => {
    const dispatch = useDispatch()
    const classesTextField = textFieldCss()
    const classesFooterCss = footerCss()
    const { user } = useSelector(state => state ? state.user : null)
    Translation.init();
    //const { version } = useSelector(state => state ? state.version : null)

    const [Username, setUsername] = useState("")
    const [Password, setPassword] = useState("")
    const [Email, setEmail] = useState("")
    const [RegistryLoaded, setRegistryLoaded] = useState(false)
    const [OpenOldLogin, setOpenOldLogin] = useState(false)
    const [OpenRecoveryPassword, setOpenRecoveryPassword] = useState(false)
    var lastPathIsEdit = false

    const [addRequestStatus, setAddRequestStatus] = useState('idle')
    const onSetUsername = (e) => setUsername(e.target.value)
    const onSetPassword = (e) => setPassword(e.target.value)
    const onSetEmail = (e) => setEmail(e.target.value)

    const canSave = [Username, Password].every(Boolean) && addRequestStatus === 'idle'

    //ALERT
    const [alertMessage, setAlertMessage] = useState({ title: null, message: null })
    const [alertActive, setAlertActive] = useState(false)

    var decodeUri = decodeURIComponent(window.location.search)
    var errorMsg = decodeUri.indexOf("errorMsg") != -1 ? decodeUri.split("_").join(" ").substring(decodeUri.indexOf("errorMsg") + 9, (decodeUri.indexOf("&") != -1 ? decodeUri.indexOf("&") : undefined)) : null
    const [snackObj, setSnackObj] = useState({ title: null, message: errorMsg, type: decodeUri.indexOf("errorMsg") == -1 ? 'info' : 'warning' })
    const [snackActive, setSnackActive] = useState(decodeUri.indexOf("errorMsg") == -1 ? false : true)
    var decodeUri = decodeURIComponent(window.location.search)

    //per gestire un F5 sempre da autenticati
    const [pushInit, setPushInit] = useState(user !== null ? false : true)

    /*let reload = false;
    document.addEventListener("keydown", (e) => {
         //116 => F5
         //123 => F12
         //73 => I
        
        if (e.keyCode === 116) {
            reload = true;
        }

        const con = e.ctrlKey && e.shiftKey && e.keyCode === 73
        //impedisce apertura console
        if (con || e.keyCode === 123) {
            //e.preventDefault();
        }
    })*/

    window.addEventListener("beforeunload", (e) => {
        const debug = true
        if (!debug) {
            e.preventDefault()
            e.returnValue = ''
        }
        //reload = false;
    })

    const onClickLogin = async (e) => {
        e.preventDefault()
        if (canSave) {
            try {
                setAddRequestStatus('pending')
                setCookie("idsrv.session", "1")
                const resultAction = await dispatch(
                    login({ Username, Password })
                )
                if (resultAction.payload !== undefined && resultAction.payload !== "")
                    setSnackObj({ message: 'LOGGED_IN', type: 'success' })
                else {
                    setSnackObj({ message: 'Username or Password incorrect', type: 'error' })
                    setCookie("idsrv.session", "", 0)
                }
                setSnackActive(true)

                setPushInit(false)

                unwrapResult(resultAction)
                setUsername('')
                setPassword('')
            } catch (err) {
                console.error('Failed to login: ', err)
            } finally {
                setAddRequestStatus('idle')
            }
        }
    }

    const onClickOpenRecoveryPassword = async (e) => {
        e.preventDefault()
        await dispatch(recoveryPassword(Email))
        setSnackObj({ message: 'Recovery Email Sended', type: 'success' })
        setSnackActive(true)
        setEmail("")
        setOpenRecoveryPassword(false)
    }

    const loadRegistry = () => {
        if (RegistryLoaded) return;
        setRegistryLoaded(true)
        dispatch(fetchCountries())
        dispatch(fetchDevices())
        dispatch(fetchLanguages())
        dispatch(fetchTranslations())
        dispatch(fetchSupervisors())
        dispatch(fetchVarFieldAttachments())
    }

    // gestisco il caso in cui si esce da Edit
    const manageRender = (Component, props) => {
        if (lastPathIsEdit) {
            lastPathIsEdit = false
            dispatch(setEditVarId({ varId: null }))
        }
        if (props.match.path === "/active/edit/:varId") lastPathIsEdit = true
        return <Component {...props} />
    }

    const packageJson = require("../package.json");
    (global).appBuildDate = new Date(packageJson.buildDate);

    let content
    if (user !== null && (getCookie("idsrv.session") !== undefined && getCookie("idsrv.session") !== "")) {
        if (!pushInit && !isIOS()) {
            AskPushSubscription('ask', true, setAlertMessage, setAlertActive)
            setPushInit(true)
        }
        content = (<Router history={history}>
            <Navbar />
            <div className="App">
                <Switch>
                    <SentryRoute exact path="/active" render={(props) => manageRender(ActiveVarsList, props)} />
                    <SentryRoute exact path="/pending" render={(props) => manageRender(PendingVarsList, props)} />
                    <SentryRoute exact path="/history" render={(props) => manageRender(HistoryVarsList, props)} />
                    <SentryRoute exact path="/active/:varId" render={(props) => manageRender(VarPage, props)} />
                    <SentryRoute exact path="/pending/:varId" render={(props) => manageRender(VarPage, props)} />
                    <SentryRoute exact path="/history/:varId" render={(props) => manageRender(VarPage, props)} />
                    <SentryRoute exact path="/active/edit/:varId" render={(props) => manageRender(VarEditForm, props)} />
                    <SentryRoute exact path="/profile" render={(props) => manageRender(ProfileForm, props)} />
                    <SentryRoute exact path="/userlanguage" render={(props) => manageRender(UserLanguageForm, props)} />
                    <SentryRoute exact path="/help" render={(props) => manageRender(HelpForm, props)} />
                    <SentryRoute exact path="/test/:varId" render={(props) => manageRender(Test, props)} />
                    <SentryRoute exact path="/logout" render={(props) => manageRender(() => Logout(setSnackObj, setSnackActive, setRegistryLoaded), props)} />
                    <Redirect to="/active" />
                </Switch>
            </div>
            {loadRegistry()}
            <CustomizedSnackbars snackActive={snackActive} setSnackActive={setSnackActive} info={snackObj} setInfo={setSnackObj} />
            <AlertDialog alertActive={alertActive} setAlertActive={setAlertActive} info={alertMessage} />
        </Router>)
    } else {
        var tryAzureB2C = getCookie("tryAzureB2C")
        if (tryAzureB2C == null || tryAzureB2C != "1") {
            window.location.href = `${urlRedirectMicrosoft}/AppLogin/AppLoginValidationExternalIDP`
            return <React.Fragment></React.Fragment>
        }
        // #region OldLogin
        content = (<Container maxWidth="md">
            <Box mt="3rem">
                <Grid>
                    <form>
                        <Card className="">
                            <Box p="5px" />
                            <Box mb="1.5rem" px="2rem" align="center" style={{ borderLeft: "5px solid #4db5ff" }}><img style={{ width: "90%" }} src={LogingLogo} alt="logo" /></Box>
                            {!OpenOldLogin ?
                                (<React.Fragment>
                                    <Box p="2rem 2rem 0 2rem" mb="1rem">
                                        Some error encoutered during the login process.<br />
                                        Try to contact an administrator.<br />
                                        <b>{errorMsg}</b><br />
                                        <br />
                                        <hr />
                                        <br />
                                        Login methods:
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} sm={6} md={4} mb="0.5rem">
                                                <div style={{ color: "black", cursor: "pointer", border: '1px solid black', height: 45, minWidth: 240, width: 240, display: "flex", alignItems: "center" }}
                                                    onClick={() => { window.location.href = `${urlRedirectMicrosoft}/AppLogin/AppLoginValidationExternalIDP` }}>
                                                    <img src={MicrosoftLogo} style={{ margin: "12px" }} />&nbsp;
                                                    <span>Sign in with Azure B2C</span>
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4} mb="0.5rem">
                                                <div style={{ color: "black", cursor: "pointer", border: '1px solid black', height: 45, minWidth: 240, width: 240, display: "flex", alignItems: "center" }}
                                                    onClick={() => { setOpenOldLogin(true) }}>
                                                    &nbsp;&nbsp;&nbsp;<span>Sign in with normal login</span>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </React.Fragment>) :
                                (<React.Fragment>{!OpenRecoveryPassword ?
                                    (<Box p="2rem 2rem 0 2rem" mb="1rem">
                                        <Box>
                                            <TextField required name="Username" className={classesTextField.root} fullWidth onChange={onSetUsername} value={Username} label="Username" />
                                        </Box>
                                        <Box mb="2.5rem">
                                            <TextField required name="Password" className={classesTextField.root} fullWidth type="password" onChange={onSetPassword} value={Password} label="Password" />
                                        </Box>
                                        <BlueButton variant="contained" color="primary" disabled={!canSave} onClick={onClickLogin} type="submit">LOGIN</BlueButton>
                                        <Typography color="textSecondary" classes={classesFooterCss} align="center">
                                            <b style={{ cursor: "pointer" }} onClick={() => { setOpenRecoveryPassword(true); setEmail("") }}>Forgot password ?</b><br />
                                        </Typography>
                                        <div style={{ color: "black", cursor: "pointer", margin: '0 auto', border: '1px solid black', height: 45, width: 240, display: "flex", alignItems: "center" }}
                                            onClick={() => { window.location.href = `${urlRedirectMicrosoft}/AppLogin/AppLoginValidationExternalIDP` }}>
                                            <img src={MicrosoftLogo} style={{ margin: "12px" }} />&nbsp;
                                            <span>Sign in with Azure B2C</span>
                                        </div>
                                        <br />
                                        <Typography color="textSecondary" classes={classesFooterCss} align="center">
                                            Please contact UNICEF Supply Division (<a target="_blank" rel="noopener noreferrer" href="https://www.unicef.org/supply">https://www.unicef.org/supply</a>) to submit feedback, queries and for Log-in Details
                                        </Typography>
                                    </Box>)
                                    :
                                    (<Box p="2rem 2rem 0 2rem" mb="1rem">
                                        <Button variant="contained" onClick={() => { setOpenRecoveryPassword(false); setEmail('') }} type="submit">Back to login</Button>
                                        <Box mb="2.5rem" mt="0.5rem">
                                            <TextField required name="Email" className={classesTextField.root} fullWidth onChange={onSetEmail} value={Email} label="Email" />
                                        </Box>
                                        <BlueButton variant="contained" color="primary" disabled={!Email} onClick={onClickOpenRecoveryPassword} type="submit">Recover Password</BlueButton>
                                        <Typography color="textSecondary" classes={classesFooterCss} align="center">
                                            <br />
                                            Please contact UNICEF Supply Division (<a target="_blank" rel="noopener noreferrer" href="https://www.unicef.org/supply">https://www.unicef.org/supply</a>) to submit feedback, queries and for Log-in Details
                                        </Typography>
                                    </Box>)}
                                </React.Fragment>)}
                            <Typography color="textSecondary" style={{ float: "right" }}>App version {ToShortDate(global.appBuildDate)} </Typography>
                        </Card>
                    </form>
                    <CustomizedSnackbars snackActive={snackActive} setSnackActive={setSnackActive} info={snackObj} setInfo={setSnackObj} />
                </Grid>
            </Box>
        </Container>)
        // #endregion
    }
    return content
}

export default App